export default __webpack_public_path__ + "static/bidra-i-figma4-04cf0db9fc72cb58668bea53ad599a7c.png";